// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-negated-condition, new-cap, babel/new-cap */
// @ts-expect-error: Flow to TS migration.
import { createSelector, InputSelector, OutputSelector } from "reselect"
import { OrderedSet } from "immutable"
import * as R from "ramda"
import rewriteCurrencies from "@kiwicom/nitro/lib/services/currency/services/rewriteCurrencies"

import { formatPrice, formatISO4217Price, getCurrencyName, getSymbol } from "./currencies"
import convertPrice from "../price/convertPrice"
import { getCountryCurrencies, getLanguageInfo } from "../staticData/index"
import { getCurrenciesKeys } from "./index"
// Consider move to sheet / nest
// https://docs.google.com/spreadsheets/d/1PZt_6sVxpJyA-ub54j0PhBB5lHFkRoAh1qq8yxN_ga8/edit?ts=58d4d081
const MOST_USED_CURRENCIES = ["usd", "eur", "gbp", "aud", "sek", "dkk"]
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type State = any

export const currenciesSelector = (state: State) => state.currencies
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const countrySelector = (state: any) => state.options.country

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const currencySelector: InputSelector<State, any, string> = (state) => state.options.currency

export const currenciesKeysSelector = createSelector(
  [currenciesSelector, getCurrenciesKeys],
  (allCurrencies, whitelistedCurrencies: string[]) =>
    // FIXME: a method has been detected that possibly mutates the object, consider a more
    // functional approach (Ramda might help)

    Object.keys(R.pick(whitelistedCurrencies.sort(), allCurrencies)),
)

export const getSymbolSelector = createSelector(
  [currenciesSelector],
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (currencies) => (currencyCode: any) => getSymbol(currencyCode, currencies),
)

export const getNameSelector = createSelector(
  currenciesSelector,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (currencies) => (currencyCode: any) => getCurrencyName(currencyCode, currencies),
)

export const newCurrencies = createSelector(currenciesSelector, (currencies) =>
  rewriteCurrencies(currencies),
)

export const roundISO4217AmountSelector = createSelector(
  [currenciesSelector],
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (currencies) => (amount: any, currencyCode: any) => {
    const precision = currencies[currencyCode] ? currencies[currencyCode].precision : 2
    return amount.toFixed(precision)
  },
)

export const formatPriceISO4217Selector = createSelector(
  [currenciesSelector, getLanguageInfo, currencySelector, roundISO4217AmountSelector],
  (currencies, langInfo, currency, roundAmount) => (
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    currencyCode: any,
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    price: any,
    formatThousandsAndDecimals = true,
  ) => {
    const floatPrice = parseFloat(price)
    const finalPrice =
      Math.round(floatPrice) !== floatPrice ? roundAmount(floatPrice, currency) : String(floatPrice)

    const opts = {
      currencyCode,
      price: finalPrice,
      currencies,
      langInfo,
      formatThousandsAndDecimals,
    } as const

    return formatISO4217Price(opts)
  },
)

export type ConvertPrice = (arg1: string, arg2: number) => number
export const convertPriceSelector = createSelector(
  [currenciesSelector],
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (currencies) => (currency: any, price: any) => convertPrice(price, currency, currencies),
)

export type GetFormattedPrice = (
  price: number,
  round?: boolean,
  separatePrice?: boolean,
  formatThousandsAndDecimals?: boolean,
) => string
// @ts-expect-error: Flow to TS migration.
export const getFormattedPriceSelector: OutputSelector<
  State,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  GetFormattedPrice
> = createSelector(
  [currencySelector, convertPriceSelector, currenciesSelector, getLanguageInfo],
  (currency, getConvertedPrice, currencies, langInfo) => (
    price: number,
    round: undefined | boolean,
    separatePrice: undefined | boolean,
    formatThousandsAndDecimals: undefined | boolean,
  ) => {
    const priceInCurrency = getConvertedPrice(currency, price)
    return formatPrice(
      currencies,
      langInfo,
      // @ts-expect-error: Flow to TS migration.
      currency,
      round ? Math.round(priceInCurrency) : priceInCurrency,
      formatThousandsAndDecimals,
      separatePrice,
    )
  },
)

export const getRecommendedCurrenciesSelector = createSelector(
  [countrySelector, getCurrenciesKeys, getLanguageInfo, getCountryCurrencies],
  (country, whitelistedCurrencies, languageInfo, countryCurrencies) => {
    let recommendedCurrencies = OrderedSet()

    // Detect from GeoIP
    const countryData = countryCurrencies[country]

    // @ts-expect-error: Flow to TS migration.
    if (countryData && whitelistedCurrencies.includes(countryData)) {
      recommendedCurrencies = recommendedCurrencies.add(countryData)
    }
    return (
      recommendedCurrencies
        // add currency by language
        .add(languageInfo.currency)
        // add currencies with biggest revenue and union them with previous
        // @ts-expect-error: Flow to TS migration.
        .union(MOST_USED_CURRENCIES.filter((x) => whitelistedCurrencies.includes(x)))
        .take(4)
    )
  },
)

export const getRecommendedCurrenciesSelectorJS = createSelector(
  getRecommendedCurrenciesSelector,
  (data) => data.toJS(),
)

export const getConvertedPriceSelector = createSelector(
  [currencySelector, convertPriceSelector],
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (currency, getConvertedPrice) => (price: any) => getConvertedPrice(currency, price),
)
